module.exports = __webpack_public_path__ + "images/stickers/pete-happy.ad61d60483a6bdbea532.png";